<template>
    <!-- Draft/데모 페이지. 편집기 본체는 Sv2Editor — 실제 편집 모달(QuestionMaster_v2)도 같은 것을 쓴다. -->
    <div class="sv2-page">
        <div class="sv2-load">
            <input v-model="loadCode" type="text" placeholder="문항 코드 (예: K1.2)" @keyup.enter="load">
            <button class="btn" @click="load">불러오기</button>
            <button class="btn" @click="useDemo">예시로 보기</button>
        </div>
        <sv2-editor ref="editor" :code="code" :demo="demo" />
    </div>
</template>

<script>
import Sv2Editor from '@/components/structureV2/Sv2Editor.vue';

const DEMO = {
    sub_code: 'DEMO-1.2',
    sub_type: 'radio',
    sub_name: '간접 고용 여부',
    sub_name_e: 'Indirect employment', sub_name_c: '',
    sub_description: '사내 도급·파견 등 간접 고용 인원의 현황을 묻습니다.', sub_description_e: '', sub_description_c: '',
    sub_data_header: {enable_na: true, enable_na_label: '해당 없음', enable_na_label_ea: 'N/A',
        required_answer: true, has_attachment: true, required_attachment: false, required_opt_attachment: true, submit_required: 'auto'},
    // df_subs_init 의 배점 속성 — 평가요소가 아니라 문항의 것
    calc_method: 'SUM', cap_score: 3, score_scaler: 1,
    sub_data_contents: {
        result: [],
        structure: [
            {
                text: '예, 사내 도급 또는 기타 간접 고용 인원이 존재합니다.',
                text_ea: 'Yes, we use in-house contractors or other indirect employment.',
                value: '예, 사내 도급 또는 기타 간접 고용 인원이 존재합니다.',
                element_contents: [{
                    type: 'table',
                    result: [],
                    // 실데이터의 중첩 표는 table_header 를 항상 갖는다 (staging 441/441).
                    // DFTable 은 컬럼을 이 값에서만 읽으므로 없으면 빈 표로 렌더된다.
                    table_header: ['근로자 유형', '직무', '인원 수'],
                    // 번역 머리글은 문자열이 아니라 {key, label} 객체다 (DFElement 는 로케일별로
                    // 렌더 분기가 따로이고, en/ca 본문 루프는 table_field.key 로 데이터를 찾는다).
                    table_header_ea: [
                        {key: '근로자 유형', label: 'Worker type'},
                        {key: '직무', label: 'Job'},
                        {key: '인원 수', label: 'Headcount'}
                    ],
                    structure: [
                        {
                            '근로자 유형': '사업장 내 타사 소속(도급, 사내협력사 등) 근로자',
                            '근로자 유형_ea': 'On-site workers employed by other companies',
                            '직무': '', '인원 수': '',
                            dropdown: {}, input_type: {'직무': 'text', '인원 수': 'number'},
                            placeholder: {
                                '직무': '(예) 도장, 조립, 검사 프로세스 등',
                                '직무_ea': 'e.g. painting, assembly, inspection'
                            },
                            noteditables: ['근로자 유형']
                        },
                        {
                            '근로자 유형': '인력관리회사 등을 통해 간접 고용한 근로자',
                            '근로자 유형_ea': 'Workers hired indirectly through staffing agencies',
                            '직무': '', '인원 수': '',
                            // 선택지 번역은 원문과 같은 순서의 평행 배열이다. 응답자가 고르면
                            // 저장되는 값은 언제나 원문('경비')이고 화면만 번역문으로 바뀐다.
                            dropdown: {
                                '직무': ['경비', '청소·미화', '급식'],
                                '직무_ea': ['Security', 'Cleaning', 'Catering']
                            },
                            input_type: {'인원 수': 'number'},
                            placeholder: {}, noteditables: ['근로자 유형']
                        }
                    ]
                }]
            },
            {text: '아니오, 없습니다.', text_ea: 'No, we do not.', value: '아니오, 없습니다.'},
            {text: '', value: ''}
        ]
    }
};

const DEMO_EVALS = [
    // 백엔드 SubEvaluation.serialize() 모양 그대로. 실데이터 패턴을 하나씩 담았다.
    {ev_id: 9001, order: 1, name: '간접 고용 인원을 관리함', reverse_name: '간접 고용 인원을 관리하지 않음',
     formula: "result=='예, 사내 도급 또는 기타 간접 고용 인원이 존재합니다.'",
     score: 1, importance: 'HIGH', pos_ev_code: 'A', neg_ev_code: 'C', ignore_attach: 0,
     ref_path: 'structure[0]'},                                                  // 증빙: 1번 선택지에 첨부
    {ev_id: 9002, order: 2, name: '경비 직무를 간접 고용함', reverse_name: '경비 직무 간접 고용 없음',
     formula: "structure[0]['element_contents'][0]['structure'][1]['직무']=='경비'",
     score: 1, importance: 'MEDIUM', pos_ev_code: 'B', neg_ev_code: 'C', ignore_attach: 0,
     ref_path: 'structure[0].element_contents[0].structure[1]'},                 // 증빙: 표 2행에 첨부
    {ev_id: 9003, order: 3, name: '간접 고용 인원 10명 이상', reverse_name: '10명 미만',
     formula: "float(structure[0]['element_contents'][0]['structure'][0]['인원 수']) >= 10",
     score: 0.5, importance: 'LOW', pos_ev_code: null, neg_ev_code: null, ignore_attach: 1, ref_path: null},
    {ev_id: 9004, order: 4, name: '(부정 근거) 간접 고용 없음', reverse_name: null,
     formula: "result=='아니오, 없습니다.'",
     score: 0, importance: 'MEDIUM', pos_ev_code: null, neg_ev_code: 'D', ignore_attach: 0, ref_path: null},  // 맞아도 0점
    {ev_id: 9005, order: 5, name: '(손으로 쓴 것)', reverse_name: null,
     formula: "structure[0]['2017']+structure[0]['2018']>=50",
     score: 1, importance: 'MEDIUM', pos_ev_code: null, neg_ev_code: null, ignore_attach: 0, ref_path: null}
];

export default {
    name: 'StructureEditorDraft',
    components: {Sv2Editor},
    data() { return {loadCode: '', code: '', demo: {sub: DEMO, evals: DEMO_EVALS}}; },
    methods: {
        load() {
            const c = (this.loadCode || '').trim();
            if (!c) return;
            this.demo = null;
            if (c === this.code) { this.$refs.editor.load(c); return; }   // 같은 코드면 watch 가 안 돌아 직접 부른다
            this.code = c;
        },
        useDemo() { this.code = ''; this.demo = {sub: DEMO, evals: DEMO_EVALS}; }
    }
};
</script>

<style scoped>
.sv2-page{padding:1rem 1.2rem 4rem;max-width:82rem;margin:0 auto;text-align:left}
.sv2-load{display:flex;gap:.4rem;align-items:center;flex-wrap:wrap;margin-bottom:.7rem}
.sv2-load input{width:14rem;font-size:.85rem;padding:.3rem .5rem;border:1px solid #dde2e9;border-radius:5px}
.btn{border:1px solid #dde2e9;background:#fff;color:#141921;padding:.25rem .65rem;border-radius:5px;font:inherit;font-size:.82rem;cursor:pointer}
.btn:hover{border-color:#8b95a3}
</style>
